let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("is5zu")).then(() => parcelRequire('iup85'));